const verify_account = {
    title: String("Verificación del usuario"),
};

export default verify_account;